export enum OrganizationReviewActions {
    APPROVE = 'approve',
    DISMISS = 'dismiss',
    REJECT = 'reject',
}
